import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7aeb6f9a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=7aeb6f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeb6f9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aeb6f9a')) {
      api.createRecord('7aeb6f9a', component.options)
    } else {
      api.reload('7aeb6f9a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7aeb6f9a&scoped=true&", function () {
      api.rerender('7aeb6f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/components/HeaderSearch/index.vue"
export default component.exports